import { NgModule } from '@angular/core';
import { CalendarControlComponent } from './calendar-control.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgClass } from '@angular/common';


@NgModule({
    declarations: [CalendarControlComponent],
    exports: [CalendarControlComponent],
    imports: [BsDatepickerModule, NgClass],
})
export class CalendarControlModule {
}
